import { useCallback, useContext, useState } from 'react'

import { AppContext } from 'state/appContext'
import { formartSSOGenderToHealthtoolForm } from 'utils/healthTools'

export function useCheckingYourself(defaultChecked = false) {
  const {
    state: { isLoggedIn, userInfo },
  } = useContext(AppContext)
  const [isCheckYourself, setIsCheckYourself] = useState(defaultChecked)

  const checkAvailableGenderOpt = useCallback(
    (value: string) => {
      return isLoggedIn &&
        isCheckYourself &&
        userInfo?.gender !== -1 &&
        formartSSOGenderToHealthtoolForm(userInfo?.gender || 0) === value
        ? value
        : undefined
    },

    [isLoggedIn, isCheckYourself],
  )
  return { checkAvailableGenderOpt, isCheckYourself, setIsCheckYourself }
}
